import TemplateView from '../../../../TemplateView'
import {EXPIRATION_DAYS_FOR_SHOWING_WARNING, paymentMethods} from './constants'
import messageResource from '../../../../messageResource'
import {CardBrandType} from '../../constants'
import {DateFormat} from '../../../../date_format'

export default class PaymentMethodSection extends TemplateView {
    constructor({
        onEditButtonClick = () => {},
    }) {
        super()

        this.actions = {
            onEditButtonClick,
        }

        this.params = {}

        this.state = {
            paymentMethod: null,
            hasCardInfo: false,
            lastFourDigits: '',
            brand: '',
            expiredMonth: 0,
            expiredYear: 0,
            expiresIn: -1,
            name: '',
        }

        this.onAnyStatePropertyChanged(['paymentMethod', 'hasCardInfo'], () => {
            this.$cardInfo.toggle(this.state.paymentMethod === paymentMethods.CC && this.state.hasCardInfo)
            this.$emptyCardInfo.toggle(this.state.paymentMethod === paymentMethods.CC && !this.state.hasCardInfo)
            this.$wireTransfer.toggle(this.state.paymentMethod === paymentMethods.WIRE)
            this.$check.toggle(this.state.paymentMethod === paymentMethods.CHECK)
        })

        this.onStatePropertyChanged('brand', (brand) => {
            this.$cardIcon.removeClass('other visa master amex')

            let cardBrand = 'other'
            if (~brand.indexOf(CardBrandType.VISA)) {
                cardBrand = 'visa'
            } else if (~brand.indexOf(CardBrandType.MASTERCARD)) {
                cardBrand = 'master'
            } else if (~brand.indexOf(CardBrandType.AMERICAN_EXPRESS)) {
                cardBrand = 'amex'
            }
            this.$cardIcon.addClass(cardBrand)
        })

        this.onStatePropertyChanged('lastFourDigits', (lastFourDigits) => {
            this.$cardNumber.text(messageResource.getMessage('licenses.panel.card_number', [lastFourDigits]))
        })

        this.onAnyStatePropertyChanged(['expiredMonth', 'expiredYear'], () => {
            this.$expires.text(messageResource.getMessage('licenses.panel.expires', [
                this.dateFormat.formatDate(new Date(this.state.expiredYear, this.state.expiredMonth - 1))
            ]))
        })

        this.onStatePropertyChanged('expiresIn', (expiresIn) => {
            const showWarning = expiresIn < EXPIRATION_DAYS_FOR_SHOWING_WARNING
            if (showWarning) {
                if (expiresIn > 0) {
                    const daysText = messageResource.getMessage((expiresIn > 1) ? 'common.days' : 'common.day')
                    this.$expireWarning.text(messageResource.getMessage('licenses.panel.expire_warning', [expiresIn, daysText]))
                } else {
                    this.$expireWarning.text(messageResource.getMessage('licenses.panel.expire_warning_expired'))
                }
            }
            this.$cardInfo.toggleClass('warning', showWarning)
        })

        this.onStatePropertyChanged('name', (name) => {
            this.$cardholderName.text(name.toUpperCase())
        })
    }

    templateHtml() {
        return "<div class='paymentMethodSection'>" +
               "    <div class='icon'/>" +
               "    <div class='container'>" +
               "        <div class='header'>" +
               "            <div class='text'><%=paymentMethod%></div>" +
               // TODO makovchik / fedoreeva this button is needed when ready edit pop-up
               // "            <div class='editButton'><%=editButton%></div>" +
               "        </div>" +
               "        <div class='content'>" +
               "            <div class='cardInfo'>" +
               "                <div class='cardNumber'>" +
               "                    <div class='cardBrandIcon'/>" +
               "                    <div class='number'/>" +
               "                </div>" +
               "                <div class='expires'/>" +
               "                <div class='expireWarning'/>" +
               "                <div class='name'/>" +
               "            </div>" +
               "            <div class='emptyCardInfo'>" +
               "                <div class='info'>" +
               "                    <div class='text'><%=emptyCardText%></div>" +
               "                    <div class='icons'/>" +
               "                </div>" +
               "                <div class='note'><%=emptyCardNote%></div>" +
               // TODO makovchik / fedoreeva this button is needed when ready edit pop-up
               // "                <div class='enterDetailsButton'><%=enterCardDetails%></div>" +
               "            </div>" +
               "            <div class='wireTransfer'><%=wireTransfer%></div>" +
               "            <div class='check'><%=check%></div>" +
               "        </div>" +
               "    </div>" +
               "</div>"
    }

    messageKeys() {
        return {
            paymentMethod: 'licenses.panel.payment_method',
            editButton: 'common.edit',
            emptyCardText: 'licenses.panel.empty_card_text',
            emptyCardNote: 'licenses.panel.empty_card_note',
            enterCardDetails: 'licenses.panel.enter_card_details',
            wireTransfer: 'licenses.panel.wire_transfer',
            check: 'licenses.panel.check',
        }
    }

    afterRender() {
        this.$cardInfo = this.find('.cardInfo')
        this.$emptyCardInfo = this.find('.emptyCardInfo')
        this.$wireTransfer = this.find('.wireTransfer')
        this.$check = this.find('.check')

        this.$cardNumber = this.find('.cardInfo .cardNumber .number')
        this.$cardIcon = this.find('.cardInfo .cardNumber .cardBrandIcon')
        this.$expires = this.find('.cardInfo .expires')
        this.$expireWarning = this.find('.cardInfo .expireWarning')
        this.$cardholderName = this.find('.cardInfo .name')

        this.find('.editButton').on('click', () => this.actions.onEditButtonClick())

        this.dateFormat = new DateFormat('MM/yy')
    }
}



// WEBPACK FOOTER //
// ./web/js/administration/licenses/components/companyInfoPanel/PaymentMethodSection.js